import { ClientStrings } from 'src/clients-internal/strings.model';
import { createAction } from 'typesafe-actions';

export const stringsInit =
    createAction('STRINGS:INIT')<{
        clientStrings: ClientStrings;
    }>();
